import React from "react";

// DevExtreme components
import { LoadIndicator } from 'devextreme-react/load-indicator';

export default function Loading(props) {

  const wrapperStyle = {
    display: "flex",
    height: "100%",
    //margin: "10px"
  };

  const contentStyle = {
    margin: "auto"
  }

  return (
    <div style={wrapperStyle}>
      <div style={contentStyle}>
        <LoadIndicator height={40} width={40} />
      </div>
    </div>
  );
}